<!-- ======= Breadcrumbs ======= -->
<!-- <section class="breadcrumbs"><div class="container"><div class="d-flex justify-content-between align-items-center"><h2>Fqa </h2><p-breadcrumb [model]="items"></p-breadcrumb>
            ---- <ol><li [model]="items"><a href="index.html">Home</a></li><li>Products </li></ol></div></div></section> -->
<!-- End Breadcrumbs -->
<!-- <div class="container-fluid p-0 about-fasinating-diamond-main-section"><div class="secure-shopping about-fasinating-diamond"><p-carousel [value]="bannerImageList" [numVisible]="1" [numScroll]="1" [circular]="true"
            [showIndicators]="false" [showNavigators]="false" [responsiveOptions]="carouselResponsiveOptions"><ng-template let-banner pTemplate="item"><div class="product-item"><div class="product-item-content"><div class="p-mb-1 banner-item-main"><img [src]="banner.banner_image_src" class="product-image" alt="banner" /></div></div></div></ng-template></p-carousel><div class="container-fluid p-0"><div class="section-title-wrap section-header flex-header text-center" style="justify-content: center;"><div class="section-title-text text-center pt-4"></div></div><div [innerHTML]="cmsContentData" class="section-contain"></div></div></div></div> -->
<section class="find-partner-page" id="FAQsss">
  	<div class="mobile_version-backbutton">
      <a class="mobile-header" onclick="history.back()">
        <span> <img src="../../../assets/images/tournament/backBtn.svg" alt=""></span>Frequently Ask...</a>
    </div>
  <div class="container">
    <div class="row">
      <div class="col-md-12 mobile_border_top">
        <div class="right-side-section col-md-12">
          <div class="right-top-bar">
            <div class="col-md-12">
              <div class="view-feature">
                <h2 class="title text-center pb-1" style="color: blue;">Frequently Asked Questions</h2>
                <br>

                <div class="header-nv" [ngClass]="{'Scrolled': isScrolled}">
                  <div class="list">
                    <!-- END CONTACT US SECTION -->
                    <ul>
                      <li>
                        <a [routerLink]="['/faq']" fragment="academy" pTooltip="Click To Go" tooltipPosition="top">
                          TPL Aacademy </a>
                      </li>
                      <li>
                        <a [routerLink]="['/faq']" fragment="Tournaments" pTooltip="Click To Go" tooltipPosition="top">
                          Tournaments </a>
                      </li>
                      <li>
                        <a [routerLink]="['/faq']" fragment="FindPartner" pTooltip="Click To Go" tooltipPosition="top">
                          Find a Partner </a>
                      </li>
                      <li>
                        <a [routerLink]="['/faq']" fragment="Contest" pTooltip="Click To Go" tooltipPosition="top"> TPL
                          Contest </a>
                      </li>
                      <li>
                        <a [routerLink]="['/faq']" fragment="Store" pTooltip="Click To Go" tooltipPosition="top"> TPL
                          Store</a>
                      </li>
                      <li>
                        <a [routerLink]="['/faq']" fragment="Program" pTooltip="Click To Go" tooltipPosition="top"> TPL
                          Invite Friends Program</a>
                      </li>
                      <li>
                        <a [routerLink]="['/faq']" fragment="Responsible" pTooltip="Click To Go" tooltipPosition="top">
                          Legality & Responsible Play </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div id="academy">
                  <h3 class="aco_subTitle sub-title mb-1 text-center" style="color: blue;">TPL Academy</h3>
                </div>

              </div>
            </div>
          
            <div class="accordion" id="accordionExample2">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingqOne">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#questionOne" aria-expanded="false" aria-controls="questionOne"> What are affiliated
                    tennis academies? </button>
                </h2>
                <div id="questionOne" class="accordion-collapse collapse " aria-labelledby="headingqOne"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Affiliated tennis academies are tennis training centres that have formed
                    a partnership or affiliation with the TPL App. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingqTwo">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#questionTwo" aria-expanded="false" aria-controls="questionTwo"> How do tennis
                    academies affiliate with the TPL App? </button>
                </h2>
                <div id="questionTwo" class="accordion-collapse collapse " aria-labelledby="headingqTwo"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Tennis academies affiliate with the TPL App through the Academy Feature.
                    Interested tennis academies go through the registration process after which you become an official
                    affiliated partner, and its services and offerings are promoted within the app. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapsefive"> How can I find
                    tennis academies affiliated with the app? </button>
                </h2>
                <div id="collapseThree" class="accordion-collapse collapse " aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Within the app, you can go to the Academy section to find all the
                    affiliated academies. This section will provide a list of academies, their locations, and other
                    relevant details. You can also search or filter academies based on location, available programs, or
                    specific criteria. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingfour">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapsefour" aria-expanded="false" aria-controls="collapsefour"> What are the
                    benefits of choosing an affiliated tennis academy? </button>
                </h2>
                <div id="collapsefour" class="accordion-collapse collapse " aria-labelledby="headingfour"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body">
                    <p style="margin-bottom: 10px;">Choosing an affiliated tennis academy through the app offers several
                      benefits, including:</p>
                    <ul style="list-style-type:none;">

                      <ul style="list-style-type: disc;">
                        <li>The app provides a streamlined process for finding and contacting affiliated academies.</li>
                        <li>Affiliated academies may offer special discounts, promotions, or additional resources
                          exclusively to app users. </li>
                        <li>Affiliated academies are part of a broader network within the app, allowing users to connect
                          with fellow tennis enthusiasts and share experiences with the tennis fraternity</li>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingfive">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapsefive" aria-expanded="false" aria-controls="collapsefive"> Are the
                    affiliated tennis academies reputable and trustworthy? </button>
                </h2>
                <div id="collapsefive" class="accordion-collapse collapse " aria-labelledby="headingfive"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> The app strives hard to maintain a reliable network of affiliated
                    academies. However, TPL App does not take responsibility for the conduct or functioning of the
                    academy </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingsix">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapsesix" aria-expanded="false" aria-controls="collapsesix"> Can I trust the
                    quality of coaching at affiliated tennis academies? </button>
                </h2>
                <div id="collapsesix" class="accordion-collapse collapse " aria-labelledby="headingsix"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body">
                    <p>The TPL App strives to establish affiliations with prestigious tennis academies renowned for
                      their exceptional coaching standards. However, it's important to note that the TPL App does not
                      take responsibility for the quality of coaching provided at these academies. While we carefully
                      select and affiliate with academies based on their reputation and expertise, the coaching services
                      and their standards remain under the sole responsibility of the respective academies. The TPL
                      App's role primarily focuses on providing a platform for seamless communication and encouraging a
                      vibrant tennis community. </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingseven">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseseven" aria-expanded="false" aria-controls="collapseseven"> What types of
                    training programs do affiliate tennis academies offer? </button>
                </h2>
                <div id="collapseseven" class="accordion-collapse collapse " aria-labelledby="headingseven"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body">
                    <p> Affiliated tennis academies offer a range of training programs suitable for different age groups
                      and skill levels. Types of training programs may differ depending upon the academy you choose.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingeight">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseeight" aria-expanded="false" aria-controls="collapseeight"> Can I book
                    training sessions or programs directly through the app? </button>
                </h2>
                <div id="collapseeight" class="accordion-collapse collapse " aria-labelledby="headingeight"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Unfortunately, we do not provide booking of training sessions or programs
                    as of now. However, you can directly contact the academy through the contact details provided in the
                    TPL App. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingNine">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine"> Are there any
                    discounts or special offers available for training at affiliated tennis academies? </button>
                </h2>
                <div id="collapseNine" class="accordion-collapse collapse " aria-labelledby="headingNine"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Affiliated tennis academies may offer special discounts or promotional
                    offers for app users. These discounts could be exclusive to app users or may be part of periodic
                    promotions run by the academies. The app will highlight any ongoing offers or inform users of
                    discounts available at the academy. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTen">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen"> How can I contact
                    or connect with an affiliated tennis academy through the app? </button>
                </h2>
                <div id="collapseTen" class="accordion-collapse collapse " aria-labelledby="headingTen"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> The app provides contact information to connect with affiliated tennis
                    academies. You can reach out to the academy directly through the provided contact details or use the
                    app to inquire about programs, availability, or any specific requirements. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingEleven">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven"> Can I view
                    the profiles or credentials of coaches at affiliated tennis academies? </button>
                </h2>
                <div id="collapseEleven" class="accordion-collapse collapse " aria-labelledby="headingEleven"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Yes, the app offers profiles or information about the coaches at
                    affiliated tennis academies in the coaches’ section of the respective academy profile. These
                    profiles typically include details about the coach's experience, qualifications, coaching
                    philosophy, and any notable achievements. It helps you assess the coaching expertise and make
                    informed decisions. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading1">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1"> Are there any age or
                    skill level requirements to join an affiliated tennis academy? </button>
                </h2>
                <div id="collapse1" class="accordion-collapse collapse " aria-labelledby="heading1"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> No, there are no pre-requisite requirements as the affiliated tennis
                    academies cater to various age groups and skill levels. They have programs designed specifically for
                    children, teenagers, adults, beginners, intermediate players, and advanced players. The app provides
                    information for each program, making it easier for you to find an appropriate fit. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading2">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2"> Can I participate in
                    tournaments or competitions through the affiliated tennis academy? </button>
                </h2>
                <div id="collapse2" class="accordion-collapse collapse " aria-labelledby="heading2"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> All affiliated tennis academies will organise tournaments and
                    competitions. They will offer coaching, guidance, and support for players interested in competitive
                    play. The app can provide information on any tournament opportunities or assist in connecting you
                    with affiliated academies that offer such programs. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading3">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3"> How can I provide
                    feedback and ratings about my experience with an affiliated tennis academy? </button>
                </h2>
                <div id="collapse3" class="accordion-collapse collapse " aria-labelledby="heading3"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> The app has a feedback and rating system where you can share your
                    experience about the affiliated tennis academies. You can provide ratings, write reviews, and offer
                    constructive feedback on the academy's coaching, facilities, organisation, or any other relevant
                    aspect. Your feedback helps other app users make informed decisions. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading4">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4"> Can I switch between
                    different affiliated tennis academies on the app? </button>
                </h2>
                <div id="collapse4" class="accordion-collapse collapse " aria-labelledby="heading4"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Yes, the app allows you the flexibility to choose between different
                    affiliated tennis academies based on your preferences and needs. You can explore multiple academies,
                    compare their offerings, and decide which one aligns best with your interests. You can reach out to
                    the academy directly through the provided contact details or use the app to inquire about programs,
                    availability, or any specific requirements. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading5">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5"> Are there any
                    membership or subscription fees associated with joining an affiliated tennis academy? </button>
                </h2>
                <div id="collapse5" class="accordion-collapse collapse " aria-labelledby="heading5"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Membership or subscription fees will vary among affiliated tennis
                    academies. Some academies may require a membership or enrolment fee, while others may operate on a
                    pay-per-session or pay-per-program basis. The app provides transparency by mentioning any associated
                    fees, allowing you to make informed decisions. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading6">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6"> What happens if I have
                    a complaint or issue with an affiliated tennis academy? </button>
                </h2>
                <div id="collapse6" class="accordion-collapse collapse " aria-labelledby="heading6"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> TPL will not address any issue/grievance, you can contact the affiliated
                    academy directly. If you encounter any issues or have a complaint about an affiliated tennis
                    academy, you can leave a review and TPL will downgrade their ratings and suspend their affiliation
                    in case of serious violations. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading7">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7"> Can I access additional
                    resources or educational materials related to tennis through the app's affiliated academies?
                  </button>
                </h2>
                <div id="collapse7" class="accordion-collapse collapse " aria-labelledby="heading7"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Unfortunately, this feature is currently unavailable. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading8">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapseOne"> How do I know if an
                    affiliated tennis academy is located in my area? </button>
                </h2>
                <div id="collapse8" class="accordion-collapse collapse " aria-labelledby="heading8"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> The app provides information about the locations of affiliated tennis
                    academies. You can search for academies based on your location. The app may also provide details
                    about the academy's address, contact information, and proximity to your location. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading9">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse9" aria-expanded="false" aria-controls="collapse9"> What are the types of
                    affiliation? </button>
                </h2>
                <div id="collapse9" class="accordion-collapse collapse " aria-labelledby="heading9"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Currently, we offer Premium and Standard membership. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading10">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse10" aria-expanded="false" aria-controls="collapse10"> What are the details
                    of Premium Membership? </button>
                </h2>
                <div id="collapse10" class="accordion-collapse collapse " aria-labelledby="heading10"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body">
                    <p style="margin-bottom: 10px;">The Premium Membership is valid for a duration of 1 year and is
                      priced at `36,000. The
                      benefits of Premium Membership is as follows:</p>
                    <ul style="list-style-type: none;">

                      <ul style="list-style-type: disc;">
                        <li>30 Dozen balls worth 40K free on enrolment.</li>
                        <li>Free 24 TPL Jerseys with academy co‑branding.</li>
                        <li>Top listing on the TPL App. </li>
                        <li>Licence to hold unlimited TPL ranking tournaments at the academy.</li>
                        <li>Location targeted Paid digital promotions for the academy during the tournament. </li>
                        <li>Affiliation and networking with top 100 academies of India.</li>
                        <li>Special invitation for TPL Player auctions for the director of Academy.</li>
                        <li>Court bookings during non-peak hours. </li>
                        <li>Individual promotion and bookings for the chief coach. (Find a coach)</li>
                        <li>Top 3 active academies of India to get cash rewards and special mentions during the live
                          telecast of the League.</li>
                        <li>Free digital promotions all-round the year.</li>
                        <li>Academy to get personalised referral code for TPL app. (All products and services to attract
                          commissions)</li>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading11">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse11" aria-expanded="false" aria-controls="collapse11"> What are the details
                    of Standard Membership? </button>
                </h2>
                <div id="collapse11" class="accordion-collapse collapse " aria-labelledby="heading11"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body">
                    <p style="margin-bottom: 10px;">The Standard Membership is valid for a duration of 4 months and is
                      priced at `12,000. The
                      benefits of Standard Membership is as follows:</p>
                    <ul style="list-style-type: none;">

                      <ul style="list-style-type: disc;">
                        <li>9 Dozen balls worth 12K free on enrolment.</li>
                        <li>Free 6 TPL Jerseys with academy co-branding.</li>
                        <li>Listing on the TPL App.</li>
                        <li>Licence to hold 4 TPL ranking tournaments at the academy.</li>
                        <li>Digital promotions for the academy during the tournament.</li>
                        <li>Affiliation and networking with top 100 academies of India.</li>
                        <li>Free VIP passes for TPL League Matches.</li>
                        <li>Court bookings during non-peak hours.</li>
                        <li>Academy to get personalised referral code for TPL app. ( All products and services to
                          attract)
                          commissions</li>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading121">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse121" aria-expanded="false" aria-controls="collapse121"> What happens after
                    I affiliate with the TPL App? </button>
                </h2>
                <div id="collapse121" class="accordion-collapse collapse " aria-labelledby="heading121"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> You will receive a welcome email with your login credentials. An invoice
                    of your payment will also be sent. After the registration process is complete your academy will be
                    listed on the academy feature of the TPL App. You will be given an exclusive licence to hold TPL
                    ranking tournaments at the academy. TPL will digitally promote your academy during the
                    tournament(s). Users will be able to view your academy profile and enrol or book courts during
                    non-peak hours. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading131">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse131" aria-expanded="false" aria-controls="collapse131"> Are there any base
                    requirements for me to be able to affiliate with the TPL App? </button>
                </h2>
                <div id="collapse131" class="accordion-collapse collapse " aria-labelledby="heading131"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Currently TPL is affiliating only through invites with limited academies.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading14">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse14" aria-expanded="false" aria-controls="collapse14"> I registered but I
                    haven’t received any confirmation? </button>
                </h2>
                <div id="collapse14" class="accordion-collapse collapse " aria-labelledby="heading14"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Please reach out to us on <a
                      href="mailto:support@tplsport.com">support@tplsport.com</a> and we’ll help you out
                    with the same </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading15">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse15" aria-expanded="false" aria-controls="collapse15"> I registered but my
                    academy isn’t listed on the app? </button>
                </h2>
                <div id="collapse15" class="accordion-collapse collapse " aria-labelledby="heading15"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Please reach out to us on <a
                      href="mailto:support@tplsport.com">support@tplsport.com</a> and we’ll help you out
                    with the same </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading16">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse16" aria-expanded="false" aria-controls="collapse16"> What are my login
                    details? </button>
                </h2>
                <div id="collapse16" class="accordion-collapse collapse " aria-labelledby="heading16"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> You will receive a welcome Email with your login credentials once your
                    registration process is completed successfully. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading17">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse17" aria-expanded="false" aria-controls="collapse17"> I haven’t received my
                    login details yet. What should I do? </button>
                </h2>
                <div id="collapse17" class="accordion-collapse collapse " aria-labelledby="heading17"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> You will receive a welcome Email with your login credentials once your
                    registration process is completed successfully. It takes 1-2 minutes to get your login details. If
                    you do not receive it within the stipulated time please contact us on <a
                      href="mailto:support@tplsport.com">
                      <u style="color:blue;">support@tplsport.com</u>
                    </a>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading18">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse18" aria-expanded="false" aria-controls="collapse18"> I am having trouble
                    logging in. What should I do? </button>
                </h2>
                <div id="collapse18" class="accordion-collapse collapse " aria-labelledby="heading18"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Cross check your login credentials and try again. If you are still unable
                    to login, please contact us on <a href="mailto:support@tplsport.com">
                      <u style="color:blue;">support@tplsport.com</u>
                    </a>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading19">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse19" aria-expanded="false" aria-controls="collapse19"> What happens after I
                    associate with the TPL App? </button>
                </h2>
                <div id="collapse19" class="accordion-collapse collapse " aria-labelledby="heading19"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> You will receive a welcome email with your login credentials. An invoice
                    of your payment will also be sent. After the registration process is complete your academy will be
                    listed on the academy feature of the TPL App. You will be given an exclusive licence to hold TPL
                    ranking tournaments at the academy. TPL will digitally promote your academy during the
                    tournament(s). Users will be able to view your academy profile and enrol or book courts during
                    non-peak hours. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading20">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse20" aria-expanded="false" aria-controls="collapse20"> Are there any base
                    requirements for me to be able to affiliate with the TPL App? </button>
                </h2>
                <div id="collapse20" class="accordion-collapse collapse " aria-labelledby="heading20"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Currently TPL is affiliating only through invites with limited academies.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading21">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse21" aria-expanded="false" aria-controls="collapse21"> What is the
                    difference between standard and premium membership? </button>
                </h2>
                <div id="collapse21" class="accordion-collapse collapse " aria-labelledby="heading21"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> The duration for standard membership is 4 months and premium membership
                    is 12 months. The benefits of the membership differ for premium and standard. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading22">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse22" aria-expanded="false" aria-controls="collapse22"> I have registered but
                    did not receive any confirmation? </button>
                </h2>
                <div id="collapse22" class="accordion-collapse collapse " aria-labelledby="heading22"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> You should receive your confirmation and invoice within 5-10 minutes of
                    registration. We request you to also check your spam folder. If you do not receive it within the
                    stipulated time please contact us on <a href="mailto:support@tplsport.com">
                      <u style="color:blue;">support@tplsport.com</u>
                    </a>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading23">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse23" aria-expanded="false" aria-controls="collapse23"> I registered but my
                    academy is not sing up on the app? </button>
                </h2>
                <div id="collapse23" class="accordion-collapse collapse " aria-labelledby="heading23"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> It takes 5-10 minutes for your academy to be listed on the TPL App. If
                    your academy has not been uploaded within the stipulated time please contact us on <a
                      href="mailto:support@tplsport.com">
                      <u style="color:blue;">support@tplsport.com</u>
                    </a>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading24">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse24" aria-expanded="false" aria-controls="collapse24"> What are my login
                    details? </button>
                </h2>
                <div id="collapse24" class="accordion-collapse collapse " aria-labelledby="heading24"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> You will receive a welcome Email with your login credentials once your
                    registration process is completed successfully. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading24">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2422" aria-expanded="false" aria-controls="collapse2422"> I have not
                    received
                    my login details yet? </button>
                </h2>
                <div id="collapse2422" class="accordion-collapse collapse " aria-labelledby="heading24"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> You will receive a welcome Email with your login credentials once your
                    registration process is completed successfully. It takes 5-10 minutes to get your login details. If
                    you do not receive it within the stipulated time please contact us on <a
                      href="mailto:support@tplsport.com">
                      <u style="color:blue;">support@tplsport.com</u>
                    </a>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading25">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse25" aria-expanded="false" aria-controls="collapse25"> I am unable to login.
                    What should I do? </button>
                </h2>
                <div id="collapse25" class="accordion-collapse collapse " aria-labelledby="heading25"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Cross check your login credentials and try again. If you are still unable
                    to login please contact us on <a href="mailto:support@tplsport.com">
                      <u style="color:blue;">support@tplsport.com</u>
                    </a>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading26">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse26" aria-expanded="false" aria-controls="collapse26"> How do I edit my
                    academy details? </button>
                </h2>
                <div id="collapse26" class="accordion-collapse collapse " aria-labelledby="heading26"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> To edit your academy details a. Log in using the credentials sent to you
                    b. Click on “Edit Details” and make the required changes </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading27">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse27" aria-expanded="false" aria-controls="collapse27"> How do I change my
                    password? </button>
                </h2>
                <div id="collapse27" class="accordion-collapse collapse " aria-labelledby="heading27"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> To change your password a. Log in using the credentials sent to you b.
                    Click on “Change Password” and make the required changes. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading28">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse28" aria-expanded="false" aria-controls="collapse28"> I have made the
                    payment, but it is showing as payment unsuccessful? </button>
                </h2>
                <div id="collapse28" class="accordion-collapse collapse " aria-labelledby="heading28"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> If you have made the payment and money has been debited from your account
                    but not received by us, you should expect a refund from the payment gateway within 5-7 working days.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading29">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse29" aria-expanded="false" aria-controls="collapse29"> How much time will it
                    take for the balls and jerseys to be delivered? </button>
                </h2>
                <div id="collapse29" class="accordion-collapse collapse " aria-labelledby="heading29"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Typically, delivery of balls and jerseys can take place anywhere within
                    60 days. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading30">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse30" aria-expanded="false" aria-controls="collapse30"> How do I deactivate
                    my membership? </button>
                </h2>
                <div id="collapse30" class="accordion-collapse collapse " aria-labelledby="heading30"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> You can deactivate your account from the TPL App. However, you will not
                    receive a refund for the cancellation of your membership. </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading31">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse31" aria-expanded="false" aria-controls="collapse31"> Will I get a refund
                    if I cancel my membership? </button>
                </h2>
                <div id="collapse31" class="accordion-collapse collapse " aria-labelledby="heading31"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> No, you will not get a refund for cancellation of your membership </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading32">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse32" aria-expanded="false" aria-controls="collapse32"> Can students other
                    than the ones in my academy participate in my academy‘s tournaments? </button>
                </h2>
                <div id="collapse32" class="accordion-collapse collapse " aria-labelledby="heading32"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> Yes, all the players can participate in your academy’s tournaments.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="heading33">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse33" aria-expanded="false" aria-controls="collapse33"> The balls/jersey I
                    received were defective? </button>
                </h2>
                <div id="collapse33" class="accordion-collapse collapse " aria-labelledby="heading33"
                  data-bs-parent="#accordionExample2">
                  <div class="accordion-body"> You will have to check the products at the time of delivery, in case
                    defective products are found you can reach out to us immediately on <a
                      href="mailto:support@tplsport.com">support@tplsport.com</a> Once the
                    goods are accepted we will not be able to do anything. </div>
                </div>
              </div>
              <br>
              <section id="Tournaments">
                <div class="right-top-bar">
                  <div class="col-md-12">
                    <div class="view-feature">
                      <h3 class="aco_subTitle title text-center pb-1" style="color: blue;">Tournaments</h3>
                    </div>
                  </div>
                </div>

                <div class="accordian" id="accordionExample2">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="heading34">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse34" aria-expanded="false" aria-controls="collapse34"> What are the
                        benefits of participating in a TPL tournament? </button>
                    </h2>
                    <div id="collapse34" class="accordion-collapse collapse " aria-labelledby="heading34"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> TPL tournaments offer TPL points, trophies and/or prizes for winners
                        and runner up, certificates for all participants, city/state ranking points, if applicable for
                        the particular tournament. Year-end top ranked players of each category in India will be
                        felicitated by a prominent sports personality on the live telecast of the TPL on a sports
                        channel. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="heading35">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse35" aria-expanded="false" aria-controls="collapse35"> How can I
                        participate in the tennis tournament? </button>
                    </h2>
                    <div id="collapse35" class="accordion-collapse collapse " aria-labelledby="heading35"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <ul style="list-style-type: lower-alpha;">
                          <li>Navigate to the tournament section within the app.</li>
                          <li>Select the desired tournament and click on 
                              <u>Register</u>
                          </li>
                          <li>Provide the required information d. Complete the registration process and await
                            confirmation. </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="heading36">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse36" aria-expanded="false" aria-controls="collapse36"> Is there an entry
                        fee to join the tennis tournament? </button>
                    </h2>
                    <div id="collapse36" class="accordion-collapse collapse " aria-labelledby="heading36"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Some tournaments may or may not have an entry fee. The tournament
                        details will specify if there is any fee involved and the payment method accepted. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="heading37">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse37" aria-expanded="false" aria-controls="collapse37"> What are the
                        eligibility criteria to participate? </button>
                    </h2>
                    <div id="collapse37" class="accordion-collapse collapse " aria-labelledby="heading37"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The eligibility criteria typically include: a. Age requirement. b.
                        Possession of a valid tennis skill level or rating, if specified. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="heading38">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse38" aria-expanded="false" aria-controls="collapse38"> Can I participate
                        in the tournament from any location? </button>
                    </h2>
                    <div id="collapse38" class="accordion-collapse collapse " aria-labelledby="heading38"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, you can participate in the tournament from any location as our
                        tournaments are open to all eligible players. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="heading39">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse39" aria-expanded="false" aria-controls="collapse39"> If I am from a
                        different city and I want to participate in a tournament which is held in another geographical
                        location, will I be provided accommodation? </button>
                    </h2>
                    <div id="collapse39" class="accordion-collapse collapse " aria-labelledby="heading39"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The academy will not be providing accommodation to outstation
                        players. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="heading40">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse40" aria-expanded="false" aria-controls="collapse40"> What is the
                        format of the tennis tournament? </button>
                    </h2>
                    <div id="collapse40" class="accordion-collapse collapse " aria-labelledby="heading40"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> All the details of the tournament, including the format will be
                        specified in the tournament factsheet. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="heading41">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse41" aria-expanded="false" aria-controls="collapse41"> How will the
                        matches be scheduled? </button>
                    </h2>
                    <div id="collapse41" class="accordion-collapse collapse " aria-labelledby="heading41"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The tournament organisers will post the draw which includes the match
                        schedule on the TPL App. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="heading42">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse42" aria-expanded="false" aria-controls="collapse42"> What happens if I
                        can't play a scheduled match? </button>
                    </h2>
                    <div id="collapse42" class="accordion-collapse collapse " aria-labelledby="heading42"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> If you are unable to play a scheduled match, the opponent will be
                        given a walk-over. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="heading43">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse43" aria-expanded="false" aria-controls="collapse43"> Are there any
                        specific rules or regulations I should be aware of? </button>
                    </h2>
                    <div id="collapse43" class="accordion-collapse collapse " aria-labelledby="heading43"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, each tournament will have its own set of rules and regulations
                        which will be mentioned in the tournament factsheet on the TPL App. Apart from that, a basic
                        code of conduct needs to be followed at all times. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="heading44">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse44" aria-expanded="false" aria-controls="collapse44"> How will the
                        winners be determined? </button>
                    </h2>
                    <div id="collapse44" class="accordion-collapse collapse " aria-labelledby="heading44"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The winners will be determined based on the draw. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="heading45">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse45" aria-expanded="false" aria-controls="collapse45"> What are the
                        prizes for the winners? </button>
                    </h2>
                    <div id="collapse45" class="accordion-collapse collapse " aria-labelledby="heading45"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The tournament fact sheet will outline the prizes for the winners
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse46" aria-expanded="false" aria-controls="collapse46"> When will the
                        results be announced? </button>
                    </h2>
                    <div id="collapse46" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The results will be uploaded on the TPL App after the completion of
                        the tournament. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse47" aria-expanded="false" aria-controls="collapse47"> How will I
                        receive my prize if I win? </button>
                    </h2>
                    <div id="collapse47" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The prize distribution will take place at the sole discretion of the
                        organiser. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse48" aria-expanded="false" aria-controls="collapse48"> Can I participate
                        in multiple categories/tournaments simultaneously? </button>
                    </h2>
                    <div id="collapse48" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, you can participate in multiple categories/tournaments
                        concurrently if they are available. However, ensure that you have sufficient time and
                        availability to fulfil your commitments for each tournament. Be mindful of any scheduling
                        conflicts or overlapping match timings. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse49" aria-expanded="false" aria-controls="collapse49"> How can I contact
                        the tournament organiser if I have any issues or questions? </button>
                    </h2>
                    <div id="collapse49" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Contact information will be provided in the tournament fact sheet
                        within the app </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse50" aria-expanded="false" aria-controls="collapse50"> Are there any
                        penalties for misconduct or rule violations? </button>
                    </h2>
                    <div id="collapse50" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, misconduct or rule violations may result in penalties or
                        disqualification. Severe violation will result in suspension or ban. Fair play and good
                        sportsmanship are expected from all participants. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse51" aria-expanded="false" aria-controls="collapse51"> Is there a limit
                        on the number of participants in the tennis tournament? </button>
                    </h2>
                    <div id="collapse51" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The tournament details should specify whether there is a participant
                        limit. Depending on the tournament's scale and resources, there may be a maximum number of
                        participants allowed. If the participant limit is reached, further entries may be closed. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse52" aria-expanded="false" aria-controls="collapse52"> Can I withdraw
                        from the tournament after registering? </button>
                    </h2>
                    <div id="collapse52" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Withdrawal policies will be mentioned in the tournament rules.
                        Participants are allowed to withdraw within a specific withdrawal period. After this period,
                        withdrawals may not be permitted, and participants are expected to fulfil their commitments.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse53" aria-expanded="false" aria-controls="collapse53"> Will my personal
                        information be kept confidential? </button>
                    </h2>
                    <div id="collapse53" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The app has a privacy policy in place to protect your personal
                        information. Review the privacy policy to understand how your data will be collected, used, and
                        stored. Ensure that the app adhere to appropriate data protection practices and only share
                        information as necessary for the tournament's purposes. </div>
                    </div>
                  </div>
                </div>
              </section>

              <section id="FindPartner">
                <div class="right-top-bar">
                  <div class="col-md-12">
                    <div class="view-feature">
                      <h3 class="aco_subTitle title text-center pb-1" style="color: blue;">Find a Partner</h3>
                    </div>
                  </div>
                </div>

                <div class="accordian" id="accordionExample2">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse54" aria-expanded="false" aria-controls="collapse54"> How can I find a
                        tennis partner on the app? </button>
                    </h2>
                    <div id="collapse54" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <ul style="list-style-type: none;">
                          <li>To find a tennis partner on the app:</li>
                          <ul style="list-style-type: lower-alpha;">
                            <li>Set up your profile, including information such as your name, location, skill level, and
                              availability.</li>
                            <li>Explore the app's Find a Partner feature to discover potential tennis
                              pro-players/coaches/players.</li>
                            <li>Use filters to narrow down your search based on location, skill level, preferred playing
                              times, or other criteria.</li>
                            <li>Review the profiles of potential tennis partners to assess compatibility.</li>
                            <li>Initiate communication with potential partners through in-app messaging.</li>
                          </ul>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse55" aria-expanded="false" aria-controls="collapse55"> Is there a fee to
                        use the app for finding a tennis partner? </button>
                    </h2>
                    <div id="collapse55" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The TPL App charges `100 or 10% convenient fee whichever is higher.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse550" aria-expanded="false" aria-controls="collapse550"> What
                        information
                        do I need to provide when creating a profile? </button>
                    </h2>
                    <div id="collapse550" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <ul style="list-style-type: none;">
                          <li>When creating a profile, you may be asked to provide information such as:</li>
                          <ul style="list-style-type: lower-alpha;">
                            <li>Name</li>
                            <li>Location (city, state, country)</li>
                            <li>Age</li>
                            <li>Skill level (beginner, intermediate, advanced)</li>
                            <li>Preferred playing times (weekday evenings, weekends)</li>
                            <li>Contact information (email, phone number)</li>
                            <li>Upload a clip of you while playing tennis. Video will be visible on the app after it has
                              been reviewed. You will be notified once the video has been approved</li>
                            <li>Any additional details you wish to share, such as your preferred court surface or
                              playing style</li>
                          </ul>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse56" aria-expanded="false" aria-controls="collapse56"> Can I search for
                        tennis partners based on location or skill level? </button>
                    </h2>
                    <div id="collapse56" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, the TPL App allows you to search for tennis partners based on
                        location and skill level. You can filter by location or skill level to find partners who match
                        your playing ability. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse57" aria-expanded="false" aria-controls="collapse57"> How can I
                        communicate with potential tennis partners on the app? </button>
                    </h2>
                    <div id="collapse57" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Communication with potential tennis partners can typically be done
                        through in-app messaging within the TPL App. However, the in-app messaging will only be
                        available after the request has been accepted by both players. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse57" aria-expanded="false" aria-controls="collapse57"> Can I specify my
                        preferred playing times and availability? </button>
                    </h2>
                    <div id="collapse57" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, you can specify your preferred playing times and availability
                        within the app. You can set your general availability, specify certain days or times when you
                        are available to play, or even indicate recurring availability patterns (e.g., every Tuesday and
                        Thursday evenings). </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse58" aria-expanded="false" aria-controls="collapse58"> Are there any
                        safety measures in place when connecting with other users? </button>
                    </h2>
                    <div id="collapse58" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> TPL App does its best to verify the players on the app but it does
                        not take responsibility for the conduct or the information provided by the player. We are not
                        liable for the misconduct and of the player </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse59" aria-expanded="false" aria-controls="collapse59"> Can I view the
                        profiles and ratings of potential tennis partners? </button>
                    </h2>
                    <div id="collapse59" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, TPL App allows you to view the profiles of potential tennis
                        partners. Profiles include information such as their name, location, skill level, availability,
                        and any additional details they have provided. Additionally, you will be able to see ratings and
                        reviews from other users who have played with them before. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse60" aria-expanded="false" aria-controls="collapse60"> How can I arrange
                        a tennis match with a partner I found on the app? </button>
                    </h2>
                    <div id="collapse60" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <ul style="list-style-type: none;">
                          <li>To arrange a tennis match with a partner you found on the app:</li>
                          <ul style="list-style-type: lower-alpha;">
                            <li>Find a convenient time to play</li>
                            <li>Select a suitable tennis court or venue for the match</li>
                            <li>Search for a partner and send a request to a potential partner and meet the payment
                              requirements</li>
                            <li>Wait for the partner to accept your invite</li>
                            <li>If the partner accepts the request, the session is confirmed.</li>
                          </ul>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse61" aria-expanded="false" aria-controls="collapse61"> What happens if
                        my partner informs me that he/she won’t be able to turn up for a scheduled match? </button>
                    </h2>
                    <div id="collapse61" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> If you’ve booked a coach/pro player/player and he/she is not able to
                        turn up for a scheduled session, your money shall be refunded to your source account. You can
                        rate/review the coach/pro player/player accordingly which will be visible to other app users.
                        Please note that not showing up for a scheduled session will result in a violation. The
                        coach/pro player/player will receive a warning for the first violation. A 20% penalty shall be
                        imposed on the second violation and a third violation will result in a 20% penalty plus a
                        suspension of 3 months from the Find a Partner feature. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse62" aria-expanded="false" aria-controls="collapse62"> What happens if I
                        won’t be able to turn up for a scheduled match? </button>
                    </h2>
                    <div id="collapse62" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> In this case, your booking fee won’t be refunded. Your partner will
                        then accordingly rate/review you and it will be visible to other app users. Please note that not
                        showing up for a scheduled session will result in a violation. The coach/pro player/player will
                        receive a warning for the first violation. A 20% penalty shall be imposed on the second
                        violation and a third violation will result in a 20% penalty plus a suspension of 3 months from
                        the Find a Partner feature. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse63" aria-expanded="false" aria-controls="collapse63"> What constitutes
                        a violation? </button>
                    </h2>
                    <div id="collapse63" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <p>The following can be considered a violation:</p>


                        <ul class=" alpha-list">
                          <li>Misrepresentation or false information: Providing inaccurate or misleading information
                            about oneself.</li>
                          <li>Harassment or abusive behaviour: Engaging in any form of harassment, including but not
                            limited to sending unsolicited explicit messages, making derogatory comments, or engaging
                            in threats or intimidation.</li>
                          <li>Spamming or solicitation: Using the platform to send unsolicited commercial messages,
                            promote other websites or services, or engage in any form of spamming or solicitation.
                          </li>
                          <li>Inappropriate content: Sharing explicit or pornographic material, engaging in sexually
                            explicit conversations, or posting offensive or discriminatory content.</li>
                          <li>Unauthorised use or impersonation: Using someone else's identity, photos, or personal
                            information without their consent, or pretending to be someone you are not.</li>
                          <li>Violation of community guidelines: Showing up late for a session and/or leaving before
                            the session ends. Not showing up completely for a session.</li>
                          <li> Please note that the user will receive a warning for the first violation. A 20% penalty
                            shall be imposed on the second violation and a third violation will result in a 20%
                            penalty plus a suspension of 3 months from the Find a Partner feature.</li>
                        </ul>

                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse64" aria-expanded="false" aria-controls="collapse64"> Can I find tennis
                        partners for specific types of matches (e.g., singles, doubles)? </button>
                    </h2>
                    <div id="collapse64" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, the TPL App allows you to specify what partner you are looking
                        for with the help of filters such as skill level, gender, availability or more. a singles or
                        doubles partner. However you cannot find a doubles partner as of now. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse65" aria-expanded="false" aria-controls="collapse65"> Can I review and
                        rate my tennis partners on the app? </button>
                    </h2>
                    <div id="collapse65" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, you can review or rate only those tennis partners with whom you
                        have connected through the app. This feedback can be valuable for other users looking for
                        partners and can help maintain a positive and reliable community of players. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse66" aria-expanded="false" aria-controls="collapse66"> Can I search for
                        tennis partners of a specific age group or gender? </button>
                    </h2>
                    <div id="collapse66" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, you can search for tennis partners based on specific criteria
                        such as age group or gender. The app's search filters or preferences settings allow you to
                        refine your search based on these criteria. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse67" aria-expanded="false" aria-controls="collapse67"> How can I contact
                        the app's support team if I have any issues or questions? </button>
                    </h2>
                    <div id="collapse67" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> You may reach out to us on <a
                          href="mailto:support@tplsport.com">support@tplsport.com </a>. Reach out to the
                        support team for any queries, concerns, or technical issues you encounter during the contest.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse68" aria-expanded="false" aria-controls="collapse68"> Is there a limit
                        on the number of tennis partners I can connect with on the app? </button>
                    </h2>
                    <div id="collapse68" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> There are no restrictions or limitations on the number of tennis
                        partners you can connect with on the TPL App. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse69" aria-expanded="false" aria-controls="collapse69"> Can I create a
                        group or join a tennis tournament on the TPL App? </button>
                    </h2>
                    <div id="collapse69" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, you can join a tennis tournament by clicking on the Tournaments
                        section on the TPL App. Unfortunately, you cannot create a group on the TPL App </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse70" aria-expanded="false" aria-controls="collapse70"> What if I want to
                        find a long-term tennis partner? </button>
                    </h2>
                    <div id="collapse70" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> If you are interested in finding a long-term tennis partner, the TPL
                        App may provide options to indicate your preferences. You can specify in your profile or search
                        for users who are also seeking long-term partnership. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse71" aria-expanded="false" aria-controls="collapse71"> Will my personal
                        information be kept confidential on the app? </button>
                    </h2>
                    <div id="collapse71" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The TPL App does have a <a [routerLink]="['/privacy-policy']"
                          fragment="front">privacy policy</a> in place to ensure
                        the confidentiality of your personal information. Review the privacy policy to understand how
                        your data will be collected, used, and protected. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse72" aria-expanded="false" aria-controls="collapse72"> Can I find tennis
                        partners for different skill levels? </button>
                    </h2>
                    <div id="collapse72" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, most tennis apps allow you to search for tennis partners based
                        on skill level. You can indicate your own skill level in your profile or get a TPL Skill Rating
                        by playing tournaments and search for partners within your desired skill range. This helps to
                        ensure compatibility and a balanced playing experience. </div>
                    </div>
                  </div>
                </div>
              </section>

              <section id="Contest">
                <div class="right-top-bar">
                  <div class="col-md-12">
                    <div class="view-feature">
                      <h3 class="aco_subTitle title text-center pb-1" style="color: blue;">TPL Contest</h3>
                    </div>
                  </div>
                </div>

                <div class="accordian" id="accordionExample2">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse73" aria-expanded="false" aria-controls="collapse73"> How can I
                        participate in the tennis contest? </button>
                    </h2>
                    <div id="collapse73" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <ul style="list-style-type: none;">
                          <li>To participate, follow these steps:</li>
                          <ul style="list-style-type: lower-alpha;">
                            <li>Download the app from the respective app store.</li>
                            <li>Create an account or log in if you already have one.</li>
                            <li>Navigate to the tennis contest section within the app.</li>
                            <li>Select the desired contest and click on "Register" or "Join."</li>
                            <li>Complete the registration process and await confirmation.</li>
                          </ul>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse74" aria-expanded="false" aria-controls="collapse74"> Is there an entry
                        fee to join the tennis contest? </button>
                    </h2>
                    <div id="collapse74" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Some contests may have an entry fee, while others may be free to
                        enter. The contest details will specify if there is any fee involved and the payment method
                        accepted. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse75" aria-expanded="false" aria-controls="collapse75"> How do I check my
                        TPL account balance? </button>
                    </h2>
                    <div id="collapse75" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Visit the Side Navigation Menu > My Balance. Alternatively, you can
                        click on the icon on the top-right corner of the app homepage. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse76" aria-expanded="false" aria-controls="collapse76"> Where do I check
                        my transaction history on the TPL App? </button>
                    </h2>
                    <div id="collapse76" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Visit the Side Navigation Menu > My Balance. Alternatively, you can
                        click on the icon on the top-right corner of the app homepage. You can also download your
                        transaction history directly from the app. In case you face any issue, please contact us. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse77" aria-expanded="false" aria-controls="collapse77"> What are the
                        eligibility criteria to participate? </button>
                    </h2>
                    <div id="collapse77" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <ul style="list-style-type: none;">
                          <li>The eligibility criteria typically include:</li>
                          <ul style="list-style-type: lower-alpha;">
                            <li>Minimum age requirement (usually 18 years or older).</li>
                            <li>Compliance with any geographical restrictions.</li>
                          </ul>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse78" aria-expanded="false" aria-controls="collapse78"> Can I participate
                        in the contest from any location? </button>
                    </h2>
                    <div id="collapse78" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The contest's availability depends on the laws of the
                        city/state/country from which you wish to participate from. Please find below the list of states
                        from where you can’t participate:
                        <br>
                        <ul style="margin-top: 1rem;">
                          <li>
                            Assam
                          </li>
                          <li>
                            Nagaland
                          </li>
                          <li>
                            Sikkim
                          </li>
                          <li>
                            Telangana
                          </li>
                          <li>
                            Odisha
                          </li>
                          <li>
                            Andhra Pradesh
                          </li>
                        </ul>

                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse79" aria-expanded="false" aria-controls="collapse79"> How do I register
                        for the tennis contest? </button>
                    </h2>
                    <div id="collapse79" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <ul style="list-style-type: none;">
                          <li>To register:</li>
                          <ul style="list-style-type: lower-alpha;">
                            <li>Open the app and navigate to the tennis contest section.</li>
                            <li>Choose the desired contest and click on "Register" or "Join."</li>
                            <li>Follow the instructions and provide the necessary information.</li>
                            <li>Agree to the terms and conditions, if applicable.</li>
                            <li>Submit your registration and await confirmation.</li>
                          </ul>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse80" aria-expanded="false" aria-controls="collapse80"> What is the
                        format of the tennis contest? </button>
                    </h2>
                    <div id="collapse80" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The contest format will be specified in the contest details. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse81" aria-expanded="false" aria-controls="collapse81"> How will the
                        contest be scheduled? </button>
                    </h2>
                    <div id="collapse81" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Contests are typically scheduled on the basis of the International
                        Tennis Calendar. Each contest will have an entry deadline depending on the respective match
                        timings. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse82" aria-expanded="false" aria-controls="collapse82"> Are there any
                        specific rules or regulations I should be aware of? </button>
                    </h2>
                    <div id="collapse82" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, each contest will have its own set of rules and regulations.
                        Please refer to the rules and regulations page of each contest here -
                        <a [routerLink]="['/termsandcondition']" fragment="front">
                          https://www.tplsport.com/termsandcondition</a>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse83" aria-expanded="false" aria-controls="collapse83"> How will the
                        winners be determined? </button>
                    </h2>
                    <div id="collapse83" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The criteria for determining winners will be specified in the contest
                        details. Common methods include distribution by a high to low percentage basis based on number
                        of entries. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse84" aria-expanded="false" aria-controls="collapse84"> What are the
                        prizes for the winners? </button>
                    </h2>
                    <div id="collapse84" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <ul style="list-style-type: none;">
                          <li>The contest details will outline the prizes for the winners.</li>
                          <li>Prizes can include:</li>
                          <ul style="list-style-type: lower-alpha;">
                            <li>Cash rewards.</li>
                            <li>Coins depending on the contest joined. Click here to know how the prize will be
                              distributed. </li>
                          </ul>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse85" aria-expanded="false" aria-controls="collapse85"> When will the
                        winners be announced? </button>
                    </h2>
                    <div id="collapse85" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The announcement timeline will be mentioned in the contest details.
                        Typically, winners are announced after the completion of the contest, once the final results are
                        compiled and verified. Participants may be notified through the app, email, or the contest
                        organizer's designated communication channels. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse86" aria-expanded="false" aria-controls="collapse86"> How will I
                        receive my prize if I win? </button>
                    </h2>
                    <div id="collapse86" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The cash/coins will be automatically credited to your TPL App wallet.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse87" aria-expanded="false" aria-controls="collapse87"> Can I participate
                        in multiple tennis contests simultaneously? </button>
                    </h2>
                    <div id="collapse87" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, you can participate in multiple contests concurrently if they
                        are available. However, ensure that you have sufficient balance in your wallet. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse88" aria-expanded="false" aria-controls="collapse88"> How can I contact
                        the support team if I have any issues or questions? </button>
                    </h2>
                    <div id="collapse88" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> You may reach out to us on <a href="mailto:support@tplsport.com">
                          support@tplsport.com</a>. Reach out to the
                        support team for any queries, concerns, or technical issues you encounter during the contest.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse89" aria-expanded="false" aria-controls="collapse89"> Are there any
                        penalties for misconduct or rule violations? </button>
                    </h2>
                    <div id="collapse89" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, misconduct or rule violations may result in penalties or
                        disqualification. Please refer to the Terms & Conditions for more details. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse90" aria-expanded="false" aria-controls="collapse90"> Is there a limit
                        on the number of participants in the tennis contest? </button>
                    </h2>
                    <div id="collapse90" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The contest details should specify whether there is a participant
                        limit. Depending on the contest's scale and resources, there may be a maximum number of
                        participants allowed. If the participant limit is reached, further entries may be closed, or a
                        waiting list may be created. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse901" aria-expanded="false" aria-controls="collapse901"> Can I withdraw
                        from the contest after registering? </button>
                    </h2>
                    <div id="collapse901" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Once you enter a particular contest, you cannot withdraw from the
                        same </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse91" aria-expanded="false" aria-controls="collapse91"> Will my personal
                        information be kept confidential? </button>
                    </h2>
                    <div id="collapse91" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The app has a privacy policy in place to protect your personal
                        information. Review the <a [routerLink]="['/privacy-policy']"
                          fragment="front">https://www.tplsport.com/privacy-policy</a> to understand how your data will
                        be collected, used, and stored. The app and organizers adhere to appropriate data protection
                        practices and only share information as necessary for the contest's purpose. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse92" aria-expanded="false" aria-controls="collapse92"> How do I withdraw
                        my winnings to my bank account? </button>
                    </h2>
                    <div id="collapse92" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> In order to withdraw your winnings, you have to first complete the
                        KYC process and enter your bank details. You can withdraw your winnings from the TPL App wallet
                        after a minimum balance of `1000 has been reached. The amount will be credited to your account
                        within 3-5 working days after you select to withdraw. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse93" aria-expanded="false" aria-controls="collapse93"> Why is the amount
                        credited in my bank account different from my withdrawal amount? </button>
                    </h2>
                    <div id="collapse93" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> According to the new Govt. Tax (TDS) law, effective 1st April 2023,
                        TDS is deducted at 30% of your net winnings, at the time of withdrawal. E.g, if you place a
                        withdrawal of Rs. 100, an amount of Rs. 30 (i.e. 30% of Rs. 100) will be deducted as TDS and Rs.
                        70 will be credited to your verified bank account. Please note: TDS is applicable only on the
                        taxable amount. We recommend that you go through the Government notification attached at the
                        bottom for complete details on this new TDS law. You can also refer to this Times Of India
                        <a target="_blank"
                          href="https://timesofindia.indiatimes.com/business/budget/budget-2023-how-your-winnings-from-online-games-will-now-get-taxed-from-april-1/articleshow/99149405.cms?from=mdr.">
                          article</a> to get a simplified version of these TDS changes
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse94" aria-expanded="false" aria-controls="collapse94"> Will there be any
                        tax deducted on my winnings? </button>
                    </h2>
                    <div id="collapse94" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> A 30% tax will be deducted on the taxable amount at the time of
                        withdrawal, as per the new Govt. Tax (TDS) law, effective 1st April 2023 (you can also refer to
                        this Times Of India article to get a simplified version of these TDS changes). </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse95" aria-expanded="false" aria-controls="collapse95"> My withdrawal
                        request is cancelled, what should I do now? </button>
                    </h2>
                    <div id="collapse95" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> A withdrawal request is usually cancelled if there’s an issue with
                        your verified bank account. Please verify your bank account with the correct details and place a
                        fresh withdrawal request. Just ensure your bank IFSC code is NOT a part of the updated IFSC
                        list. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse96" aria-expanded="false" aria-controls="collapse96"> How do I withdraw
                        my coins? </button>
                    </h2>
                    <div id="collapse96" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> You can use the coins to join more contests and increase your
                        winnings, but you cannot withdraw it. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse97" aria-expanded="false" aria-controls="collapse97"> Can I use someone
                        else's bank details on my TPL account? </button>
                    </h2>
                    <div id="collapse97" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> You can verify ONLY your own bank account.<br> PS: If you don’t have
                        a bank account, your winnings will keep accumulating
                        in
                        your TPL account and you can use them to join contests. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse98" aria-expanded="false" aria-controls="collapse98"> Is there a daily
                        withdrawal limit? </button>
                    </h2>
                    <div id="collapse98" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, there is. You can place up to 3 withdrawal requests a day, not
                        exceeding a total value of `1.5lakhs. Each withdrawal request can be for a minimum of `1000 and
                        a maximum of `50000. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse99" aria-expanded="false" aria-controls="collapse99"> Does TPL send
                        information about lucky draws or contests via post/ courier? </button>
                    </h2>
                    <div id="collapse99" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> TPL communicates with its users via the mobile app, SMS or emails to
                        your registered email ID.<br> We do not send any communication via post/ courier, or through any
                        other apps or links.<br> Check the TPL App mobile app or reach out to us via
                        <strong><u>Helpdesk</u></strong> for any further details.<br> Keeping your TPL App account
                        secure is
                        of
                        paramount importance to us, and we are committed to ensuring that your personal details are
                        protected and safe.<br> Please report any suspicious activity immediately to us by emailing us
                        on
                        <a href="mailto:support@tplsport.com">support@tplsport.com </a><br>If you have shared any
                        details
                        with another person, please report such
                        activity to us.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse100" aria-expanded="false" aria-controls="collapse100"> How to set a
                        strong password for your TPL Account? </button>
                    </h2>
                    <div id="collapse100" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Try setting it using the below do’s and don'ts <table>
                          <table style="width: 100%;">
                            <tr style="border: 1px solid black;">
                              <th style="border: 1px solid black;">Always Have/Do’s</th>
                              <th style="border: 1px solid black;">Never Have/Don’ts</th>
                            </tr>
                            <tr style="border: 1px solid black;">
                              <td style="border: 1px solid black;">✅ Combination of alphabets, numbers are special
                                characters</td>
                              <td style="border: 1px solid black;">❌ Mobile number, name, DOB or any other personal
                                details </td>
                            </tr>
                            <tr style="border: 1px solid black;">
                              <td style="border: 1px solid black;">✅ Minimum 8 characters</td>
                              <td style="border: 1px solid black;">❌ Share with anyone, even by mistake</td>
                            </tr>
                            <tr>
                              <td style="border: 1px solid black;">✅ Change it every 3 months</td>
                              <td style="border: 1px solid black;">❌ Password used on other sites/ app</td>
                            </tr>
                          </table>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse101" aria-expanded="false" aria-controls="collapse101"> How can I keep
                        my TPL App account safe? </button>
                    </h2>
                    <div id="collapse101" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <p>Keeping your TPL App account secure is of paramount importance to us. Here are 5 essential
                          tips to keep in mind:</p>
                        <ul style="list-style-type: none;">

                          <ul style="list-style-type: disc;">
                            <li>Do not share your OTP with anyone. No one working at TPL App will ever ask you for any
                              OTP, so please don’t share it with anyone.</li>
                            <li>Do not share sensitive information (like your mobile number, email ID, PAN number, Bank
                              account number etc.) with other players on the TPL App platform or with anyone outside our
                              platform. </li>
                            <li>Do not download unverified and unauthorised apps that you don’t trust. We do not promote
                              any of these apps.</li>
                            <li>TPL App does not share Cash Bonus, Discounts or Vouchers on other platforms nor send any
                              such communication via post/mail. We provide our players with Cash Bonuses and other
                              discounts from time to time, but these are given directly only on the TPL App App so do
                              not trust apps that promise to give you TPL App cash bonus, discounts or vouchers.</li>
                            <li>Report any fraudulent activity immediately. If you have shared any details with another
                              person, please report such activity to us via our email id.</li>
                          </ul>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse102" aria-expanded="false" aria-controls="collapse102"> Can I transfer
                        the balance from one TPL account to another? </button>
                    </h2>
                    <div id="collapse102" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Your balance is specific to your account and cannot be transferred to
                        any other TPL account. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse103" aria-expanded="false" aria-controls="collapse103"> I think someone
                        else is using my account, what should I do now? </button>
                    </h2>
                    <div id="collapse103" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> If you think your account is hacked, please change your password
                        immediately! Now, head to “My Info & Settings” from the Profile menu, scroll down and log out.
                        This will make sure you’ve successfully logged out from all your devices. You can login with the
                        new password and start playing on the TPL App again. If you still think the account is being
                        used by someone else, please contact us and we’ll help you resolve the issue. Note: Always set a
                        strong password and keep changing it every three months Never share your login details or OTP
                        with anyone </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse104" aria-expanded="false" aria-controls="collapse104"> My amount was
                        not added to my TPL App account, when will I get my refund? </button>
                    </h2>
                    <div id="collapse104" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Refunds depend on the mode of payment. In case a refund for any
                        failed deposit transaction is not credited to your source account within the below time frame,
                        please reach out to your bank for more details. <table style="width: 80%;">
                          <tr style="border: 1px solid black;">
                            <th style="border: 1px solid black;">Payment Mode</th>
                            <th style="border: 1px solid black;">Refund Duration</th>
                          </tr>
                          <tr style="border: 1px solid black;">
                            <td style="border: 1px solid black;">Wallets</td>
                            <td style="border: 1px solid black;">Within 2 Hours</td>
                          </tr>
                          <tr style="border: 1px solid black;">
                            <td style="border: 1px solid black;">Debit/Credit Card</td>
                            <td style="border: 1px solid black;">Within 2-3 Working Days</td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid black;">Net Banking </td>
                            <td style="border: 1px solid black;">Within 2-3 Working Days</td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid black;">UPI </td>
                            <td style="border: 1px solid black;">Within 24 Hours</td>
                          </tr>
                        </table> PS: Working days exclude weekends and bank holidays. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse105" aria-expanded="false" aria-controls="collapse105"> How many
                        contests can I join? </button>
                    </h2>
                    <div id="collapse105" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> We'd want you to have all the opportunities to apply your skill and
                        win big! You can join as many contests as you want but we request you to play responsibly </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse106" aria-expanded="false" aria-controls="collapse106"> Which type of
                        contests can I join? </button>
                    </h2>
                    <div id="collapse106" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Any contest you want! Select your favourite match, click on a match,
                        answer the questions and join any cash/coins contests of your choice. Keep playing and winning
                        on the TPL App. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse107" aria-expanded="false" aria-controls="collapse107"> Do unfilled
                        contests get cancelled? </button>
                    </h2>
                    <div id="collapse107" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> In the event that the minimum number of entries required for a
                        contest is not met, we regret to inform you that the contest will be cancelled. However, we
                        value your participation and want to ensure your satisfaction. Rest assured, any coins or cash
                        you invested in the contest will be promptly refunded to your TPL Wallet. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse108" aria-expanded="false" aria-controls="collapse108"> Can I join a
                        contest in the middle of a series? </button>
                    </h2>
                    <div id="collapse108" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> No </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse109" aria-expanded="false" aria-controls="collapse109"> How is TDS
                        calculated? </button>
                    </h2>
                    <div id="collapse109" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <ul style="list-style-type: none;">

                          <ul style="list-style-type: disc;">
                            <li>The new Govt, Tax (TDS) law, as defined in the Finance Act, 2023, has been in effect
                              since0.
                              1 April 2023. According to the law, 30% of your taxable amount (i.e. net winnings) is
                              deducted as TDS on withdrawal.</li>
                            <li>In case of no withdrawal in the entire financial year, TDS will be deducted on net
                              winnings as on 31 March 2024.</li>
                            <li>It's important to understand how the taxable amount (i.e. net winnings) are calculated.
                            </li>
                            <li> Until 30 April 2023, the taxable amount was calculated as:</li>
                            <li>Net winnings* = Total winnings - (Total Entry Amount- Cash Bonus/Discount) (*subject to
                              change as per the rules that are to be notified under the Income Tax 1961)</li>
                            <li>We've now made a quick update on how the taxable amount is calculated to make itsimpler
                              for you.</li>
                            <li>The taxable amount is defined as the difference between your withdrawals and depositsin
                              the FY.</li>
                            <li>From 1 May 2023, the taxable amount is calculated as below:</li>
                            <li>You can also refer to this Times Of India <a target="_blank"
                                href="https://timesofindia.indiatimes.com/business/budget/budget-2023-how-your-winnings-from-online-games-will-now-get-taxed-from-april-1/articleshow/99149405.cms?from=mdr.">
                                article</a> to get a simplified version of these
                              TDS changes.</li>
                          </ul>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse1101" aria-expanded="false" aria-controls="collapse1101"> Is there any
                        threshold amount above which the TDS will be deducted? </button>
                    </h2>
                    <div id="collapse1101" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <ul style="list-style-type: disc;">
                          <li>No, TDS at 30% will be deducted on net winnings on every withdrawal amount or on net
                            winnings at the end of every financial year, effective 1st April 2023.</li>
                          <li>We recommend that you go through the Government notification attached at the bottom for
                            complete details on this new TDS law.</li>
                          <li>You can also refer to this Times Of India <a target="_blank"
                              href="https://timesofindia.indiatimes.com/business/budget/budget-2023-how-your-winnings-from-online-games-will-now-get-taxed-from-april-1/articleshow/99149405.cms?from=mdr.">
                              article</a> to get a simplified version of these TDS
                            changes.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse110" aria-expanded="false" aria-controls="collapse110"> What happens if
                        I have net losses? </button>
                    </h2>
                    <div id="collapse110" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> No TDS will be applicable in case of net losses at the time of
                        withdrawal or at the end of the financial year. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse111" aria-expanded="false" aria-controls="collapse111"> How can I check
                        all transactions and TDS-related details? </button>
                    </h2>
                    <div id="collapse111" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <ul style="list-style-type: disc;">
                          <li>Go to My Balance ➡️ My Transactions ➡️ Others</li>
                          <li>Click on the transaction for which you want to see the details.</li>
                          <li>You can check out the detailed TDS breakup for each withdrawal.</li>
                          <li>You can also download the quarterly TDS certificate here once it is published.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse112" aria-expanded="false" aria-controls="collapse112"> What happens if
                        I don’t make any withdrawals during the financial year? </button>
                    </h2>
                    <div id="collapse112" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <ul style="list-style-type: disc;">
                          <li>The taxable amount at the end of the financial year (31 March) will be subject to Govt.
                            Tax (TDS) at 30%. TDS will be deducted from your closing balance.</li>
                          <li>Note: A, B, D & E are calculated for the current FY i.e. 1 April 2023 onwards</li>
                          <li>You can refer to this Times Of India <a target="_blank"
                              href="https://timesofindia.indiatimes.com/business/budget/budget-2023-how-your-winnings-from-online-games-will-now-get-taxed-from-april-1/articleshow/99149405.cms?from=mdr.">
                              article</a> to get a simplified version of these TDS
                            changes.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse113" aria-expanded="false" aria-controls="collapse113"> What if I end
                        up paying extra TDS? </button>
                    </h2>
                    <div id="collapse113" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Don’t worry; you can claim your TDS refund when filing your Income
                        Tax Returns (ITR) for that financial year. Make sure to download your quarterly TDS certificates
                        from the My Transactions section of the app, once published. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse114" aria-expanded="false" aria-controls="collapse114"> Will my account
                        balance, held till 31 March 2023, also get affected? </button>
                    </h2>
                    <div id="collapse114" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> No. Don't worry; your account balance holdings before 1 April 2023
                        will not incur a TDS deduction as per the new update. </div>
                    </div>
                  </div>
                </div>
              </section>

              <section id="Store">
                <div class="right-top-bar">
                  <div class="col-md-12">
                    <div class="view-feature">
                      <h3 class="aco_subTitle title text-center pb-1" style="color: blue;">TPL Store</h3>
                    </div>
                  </div>
                </div>

                <div class="accordian" id="accordionExample2">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse115" aria-expanded="false" aria-controls="collapse115"> What is the
                        store on the TPL App? </button>
                    </h2>
                    <div id="collapse115" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The store on the TPL App is an online marketplace where users can
                        browse and purchase a wide range of tennis-related products, including equipment, apparel,
                        accessories, and more. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse116" aria-expanded="false" aria-controls="collapse116"> How can I
                        access the store on the tennis app? </button>
                    </h2>
                    <div id="collapse116" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> To access the store, simply navigate to the designated store section
                        within the TPL App </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse117" aria-expanded="false" aria-controls="collapse117"> What products
                        are available in the TPL store? </button>
                    </h2>
                    <div id="collapse117" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The TPL store offers a comprehensive selection of tennis products,
                        such as tennis rackets, tennis balls, tennis shoes, tennis apparel (including shirts, shorts,
                        skirts, and dresses), tennis bags, tennis accessories (grips, strings, dampeners, etc.),
                        training equipment, and other tennis-related merchandise. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse118" aria-expanded="false" aria-controls="collapse118"> Can I purchase
                        tennis equipment and accessories from the TPL store? </button>
                    </h2>
                    <div id="collapse118" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, the TPL store provides the opportunity to purchase a wide range
                        of tennis equipment and accessories. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse119" aria-expanded="false" aria-controls="collapse119"> Are the
                        products in the store of high quality? </button>
                    </h2>
                    <div id="collapse119" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The TPL App aims to ensure that the products available in the store
                        are of high quality. However TPL does not take responsibility____. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse120" aria-expanded="false" aria-controls="collapse120"> Can I find
                        popular tennis brands in the TPL store? </button>
                    </h2>
                    <div id="collapse120" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, the TPL store includes products from popular and well-known
                        tennis brands. This may include brands like Yonex, Wilson, Babolat, Head, Prince, Nike, Adidas,
                        and other renowned tennis brands. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse1211" aria-expanded="false" aria-controls="collapse1211"> Is there a
                        variety of products to choose from? </button>
                    </h2>
                    <div id="collapse1211" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, the TPL store strives to offer a wide variety of products to
                        cater to the diverse needs and preferences of our users. You can expect a range of options in
                        terms of brands, styles, sizes, and price points to choose from. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse122" aria-expanded="false" aria-controls="collapse122"> How can I
                        search for specific items in the TPL store? </button>
                    </h2>
                    <div id="collapse122" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The TPL store has a search feature that allows you to enter specific
                        keywords or use filters to refine your search. This enables you to find the exact products you
                        are looking for quickly and easily. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse123" aria-expanded="false" aria-controls="collapse123"> Can I read
                        customer reviews for products in the TPL store? </button>
                    </h2>
                    <div id="collapse123" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, the TPL store allows customers to review and rate products.
                        Reading these reviews can provide insights into the experiences of other users who have
                        purchased and used the products, helping you make more informed purchase decisions </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse124" aria-expanded="false" aria-controls="collapse124"> Are there any
                        special offers or discounts available in the TPL store? </button>
                    </h2>
                    <div id="collapse124" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The TPL store may offer special promotions, discounts, or deals on
                        selected products from time to time. This can include seasonal sales, clearance offers, bundle
                        discounts, or loyalty rewards for app users. Such offers may be highlighted in the app or
                        communicated <u>through notifications or newsletters.</u>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse125" aria-expanded="false" aria-controls="collapse125"> How can I make
                        a purchase from the TPL store? </button>
                    </h2>
                    <div id="collapse125" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> To make a purchase, select the desired product from the store and add
                        it to your shopping cart. Once you have completed your shopping, proceed to the checkout
                        process, where you will be required to provide shipping and payment information. After
                        confirming your order, the purchase will be processed. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse126" aria-expanded="false" aria-controls="collapse126"> What payment
                        methods are accepted in the TPL store? </button>
                    </h2>
                    <div id="collapse126" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The TPL store accepts various payment methods, such as credit cards,
                        debit cards, digital wallets (e.g., Paytm, Google Pay) </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse127" aria-expanded="false" aria-controls="collapse127"> Is my personal
                        and payment information secure when making a purchase? </button>
                    </h2>
                    <div id="collapse127" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The TPL app prioritises the security and privacy of user information.
                        Your personal and payment information will only be used for the purchase process ____. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse128" aria-expanded="false" aria-controls="collapse128"> Can I
                        <span style="margin-left: 5px;"><u>track
                            the
                            status of my order?</u></span> </button>
                    </h2>
                    <div id="collapse128" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, the app provides order tracking functionality. Once your order
                        is confirmed, you should receive updates on its status, including shipping details and estimated
                        delivery dates. You can track the progress of your order directly within the app. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse129" aria-expanded="false" aria-controls="collapse129">
                        <div>
                          What is the
                          <span style="margin-left: 5px;margin-right: 5px;"><u> return policy</u></span> for products
                          purchased from the store?
                        </div>
                      </button>
                    </h2>
                    <div id="collapse129" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The TPL store has a return policy in place. This policy outlines the
                        conditions and procedures for returning or exchanging products if you are not satisfied with
                        your purchase. The app should provide clear information on how to initiate a return and any
                        associated guidelines or fees. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse1301" aria-expanded="false" aria-controls="collapse1301">
                        <div>
                          Can I <span style="margin-left: 5px;margin-right: 5px;"><u> exchange or refund</u></span>
                          a product if I'm not satisfied?
                        </div>
                      </button>
                    </h2>
                    <div id="collapse1301" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, if you are not satisfied with a product, the store may offer
                        options for exchanges or refunds. The return policy will specify the conditions under which
                        these options are available. Products should be in unused and resalable condition, and the
                        return must be requested within a specified timeframe. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse130" aria-expanded="false" aria-controls="collapse130"> Are there any
                        shipping fees for products purchased from the store? </button>
                    </h2>
                    <div id="collapse130" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Shipping fees may apply to purchases from the store. The TPL app
                        should provide information regarding any shipping costs associated with your order. This
                        information may depend on factors such as the destination, order value, or any ongoing free
                        shipping promotions. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse1311" aria-expanded="false" aria-controls="collapse1311"> How long does
                        it take to receive my order? </button>
                    </h2>
                    <div id="collapse1311" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The delivery time for your order can vary based on various factors,
                        including your location, the availability of the product, and the chosen shipping method. The
                        app should provide estimated delivery times during the checkout process or in the order
                        confirmation email. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse132" aria-expanded="false" aria-controls="collapse132"> Can I contact
                        customer support if I have any issues with my purchase? </button>
                    </h2>
                    <div id="collapse132" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, the app should have a customer support system in place to
                        address any issues or concerns you may have with your purchase. You can reach out to the app's
                        support team through designated contact channels, such as email, chat support, or a customer
                        helpline. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse133" aria-expanded="false" aria-controls="collapse133"> Are there any
                        loyalty or rewards programs associated with the store? </button>
                    </h2>
                    <div id="collapse133" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The tennis app may have a loyalty or rewards program associated with
                        the store. This program could offer benefits such as earning points for purchases, exclusive
                        discounts, early access to promotions, or other perks for frequent customers. The app should
                        provide details on how to participate and benefit from the loyalty program. </div>
                    </div>
                  </div>
                </div>
              </section>

              <section id="Registration">
                <div class="right-top-bar">
                  <div class="col-md-12">
                    <div class="view-feature">
                      <h3 class="aco_subTitle title text-center pb-1" style="color: blue;">TPL Login and Registration </h3>
                    </div>
                  </div>
                </div>
 
                <div class="accordian" id="accordionExample2">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse134" aria-expanded="false" aria-controls="collapse134"> How do I
                        register? </button>
                    </h2>
                    <div id="collapse134" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">


                        <ul style="list-style-type: disc;">
                          <li>Download the TPL App on your phone or head to <a
                              href="https://www.tplsport.com/">www.tplsport.com</a></li>
                          <li>Register with your mobile number & OTP or email address and password. And that’s it!
                          </li>
                          <li>Select your feature & start your journey</li>
                          <li>Please make sure to add your Email ID for the latest updates and to connect with us.
                          </li>
                        </ul>

                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse135" aria-expanded="false" aria-controls="collapse135"> How do I
                        register using an Invite Code? </button>
                    </h2>
                    <div id="collapse135" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <ul style="list-style-type: disc;">
                          <li>Click on the link you received with the code and download the TPL App.</li>
                          <li>Once you open the app, you’ll see the option to “Enter Code” on the left-hand bottom
                            corner. Tap that, enter your Invite Code, your mobile number, and email ID, and select a
                            password of your choice.</li>
                          <li>Tap “Register,” and that’s it!</li>
                          <li>Welcome to TPL App, and congrats on winning 1000 coins worth Rs.100 for joining with your
                            friend’s invite code. Let the games begin!</li>
                          <li>Here's all you need to know about the <a href="#" target="_blank"
                              rel="noopener noreferrer"></a> Invite Friends Program!</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse136" aria-expanded="false" aria-controls="collapse136"> How do I change
                        my password? </button>
                    </h2>
                    <div id="collapse136" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <ul style="list-style-type: disc;">
                          <li>Head to Avatar > My Profile > Edit Profile > Security Details > Change password and done.
                            Don't forget to
                            update the
                            changes.</li>
                          <li>PS: Please set a strong password and DO NOT share it with anyone to keep your account
                            safe. If you <a href="https://www.tplsport.com/sign-in">forgot your password</a>, you need
                            to reset it.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse137" aria-expanded="false" aria-controls="collapse137"> I forgot my
                        password. How do I reset it? </button>
                    </h2>
                    <div id="collapse137" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> You no longer need to maintain a password. Simply, login with your
                        mobile number or email ID. Enter the OTP sent on your registered mobile number or on your email
                        id. And that’s it! </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse138" aria-expanded="false" aria-controls="collapse138"> Why can't I use
                        Facebook or Google login options on iOS any more? </button>
                    </h2>
                    <div id="collapse138" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <p>Due to Apple’s policies, we have disabled the Facebook and Google login options from
                          v3.67.0 onwards for our iOS app. But your experience remains unchanged! Here’s how you can
                          log in next time:</p>
                        <ul style="list-style-type: none;">

                          <ul style="list-style-type: disc;">
                            <li>Use your verified mobile number and log in via OTP OR</li>
                            <li>Use the same email ID associated with your Google/ Facebook login you were using
                              earlier. Tap on ‘Forgot Password’ to reset, create a new password and you're all set.</li>
                          </ul>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse139" aria-expanded="false" aria-controls="collapse139"> I forgot the
                        email ID I used to register on the TPL App. How do I log in now? </button>
                    </h2>
                    <div id="collapse139" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> If you forgot your registered email ID, log in using your verified
                        mobile number instead. An OTP will be sent to your mobile number for verification. Welcome back!
                        If you need more help figuring out your login credentials, do write to us. We're always here to
                        help. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse140" aria-expanded="false" aria-controls="collapse140"> I forgot the
                        mobile number I used to register. How do I log in now? </button>
                    </h2>
                    <div id="collapse140" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> If you forgot your registered mobile number, log in using your email
                        id instead. An OTP will be sent to your email id for verification. Welcome back! If you need
                        more help figuring out your login credentials, do write to us. We're always here to help. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse141" aria-expanded="false" aria-controls="collapse141"> I am not
                        receiving the OTP. What should I do? </button>
                    </h2>
                    <div id="collapse141" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> You will receive the OTP via SMS or on your registered email id. If
                        you still haven’t received the OTP, tap on ‘Resend’ to receive a new OTP again. Make sure you’re
                        at a spot that has a good cellular network and try again. Note: Please check if you've entered
                        the correct mobile number. Also, make sure your number is not registered as DND for our app.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse142" aria-expanded="false" aria-controls="collapse142"> My TPL App
                        account is suspended. How do I activate it? </button>
                    </h2>
                    <div id="collapse142" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Please write to us with a copy of your PAN Card and we'll help you
                        out. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse143" aria-expanded="false" aria-controls="collapse143"> How do I change
                        my email ID? </button>
                    </h2>
                    <div id="collapse143" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Unfortunately, you can’t change your email id. If you still have any
                        queries, please reach out to us via <a
                          href="mailto:support@tplsport.com">support@tplsport.com</a> </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse144" aria-expanded="false" aria-controls="collapse144"> How do I change
                        my mobile number? </button>
                    </h2>
                    <div id="collapse144" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Unfortunately, you can’t change your mobile number. If you still have
                        any queries, please reach out to us via <a
                          href="mailto:support@tplsport.com">support@tplsport.com</a> </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse145" aria-expanded="false" aria-controls="collapse145"> How do I change
                        my bank account? </button>
                    </h2>
                    <div id="collapse145" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <p> Changing your verified bank account is easy! All you need to do is unlink your bank
                          account and place a verification request for a new one. You can change your bank account
                          details up to 10 times via the TPL App. Now, link your new bank account from the same KYC
                          tab as shown above: Tap Bank Account and add your details, upload a bank document and
                          that's
                          it. Here are some important points to keep in mind while changing your bank account:</p>
                        <ul style="list-style-type: none;">

                          <ul style="list-style-type: disc;">

                            <li>Once verified, the same bank account can't be verified on any other TPL App account</li>
                            <li>You can verify a bank account in your name only</li>
                            <li>NRE accounts and Wallets can't be verified</li>
                          </ul>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse146" aria-expanded="false" aria-controls="collapse146"> How do I change
                        my state, gender or address? </button>
                    </h2>
                    <div id="collapse146" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Head to 'My Info & Settings' > Change your gender, state and address
                        and tap on save. In case you've already verified your PAN/ bank details, you won’t be able to
                        make any changes to the state, gender or address since they are updated as per your PAN and Bank
                        details. </div>
                    </div>
                  </div>
                </div>
              </section>

              <section id="Program">
                <div class="right-top-bar">
                  <div class="col-md-12">
                    <div class="view-feature">
                      <h3 class="aco_subTitle title text-center pb-1" style="color: blue;">TPL Invite Friends Program </h3>
                    </div>
                  </div>
                </div>

                <div class="accordian" id="accordionExample2">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse147" aria-expanded="false" aria-controls="collapse147"> What is the
                        benefit of the Invite Friends Program? </button>
                    </h2>
                    <div id="collapse147" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <ul style="list-style-type: disc;">
                          <li> For Inviters: Introducing the TPL App referral program! When you invite friends to join,
                            you'll receive an instant reward of 1000 coins as soon as they register on the app. But the
                            perks don't stop there! You'll also earn an ongoing 2% of the total amount your friends
                            spend on the app. It's a fantastic way to earn rewards while sharing the TPL App experience
                            with your friends. Start referring today and reap the benefits!</li>
                          <li>For Invitees: When you join using your friend’s referral code, you'll receive an instant
                            reward of 1000 coins as soon as you register on the app</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse148" aria-expanded="false" aria-controls="collapse148"> What does my
                        friend get when registering with my invite code? </button>
                    </h2>
                    <div id="collapse148" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> As soon as your friend registers on TPL App, he gets a 1000 coins’
                        worth up to ₹100. These coins can be used to join your first cash contest </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse149" aria-expanded="false" aria-controls="collapse149"> How to invite
                        my friends? </button>
                    </h2>
                    <div id="collapse149" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Share your invite link with your friends on WhatsApp,Telegram,
                        Messages, Facebook, Instagram, etc. Ensure they download and register on the TPL App. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse150" aria-expanded="false" aria-controls="collapse150"> What is the
                        maximum number of invites I can send? </button>
                    </h2>
                    <div id="collapse150" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> This is the best part - you can send unlimited invites, so remember
                        to send as many invites as possible to those you think will enjoy the TPL App experience just
                        like you. Start inviting now! </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse151" aria-expanded="false" aria-controls="collapse151"> How do I use my
                        Coins? </button>
                    </h2>
                    <div id="collapse151" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Use your Coins to pay for entries in contests. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse152" aria-expanded="false" aria-controls="collapse152"> What is the
                        validity of My Coins? </button>
                    </h2>
                    <div id="collapse152" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Coins on the TPL App have no validity and you can use them to redeem
                        rewards whenever you want. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse153" aria-expanded="false" aria-controls="collapse153"> Where can I
                        check my Coins history for use/earned? </button>
                    </h2>
                    <div id="collapse153" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Visit our Rewards Home from the bottom right corner. Under your Coins
                        balance, you will see Coins History. Here you will see your Coins transaction history. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse154" aria-expanded="false" aria-controls="collapse154"> Can I buy
                        Coins? </button>
                    </h2>
                    <div id="collapse154" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> No, sorry! You'll only be able to collect Coins by performing certain
                        actions. These actions are of 2 types: Every Time and One-Time. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse155" aria-expanded="false" aria-controls="collapse155"> Can I redeem
                        Coins? </button>
                    </h2>
                    <div id="collapse155" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Coins are non-redeemable but can be used to enter contests. Start
                        using your coins to join exciting contests today! </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse156" aria-expanded="false" aria-controls="collapse156"> Will I get
                        Coins if the contest is cancelled or the match gets abandoned? </button>
                    </h2>
                    <div id="collapse156" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> Yes, your Coins will be credited to your TPL Wallet </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse157" aria-expanded="false" aria-controls="collapse157"> How can I earn
                        Coins? </button>
                    </h2>
                    <div id="collapse157" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> You get 10% coins as reward for every spent on the TPL App.
                        Alternately, you can also earn coins through our referral program </div>
                    </div>
                  </div>
                </div>
              </section>

              <section id="Responsible">
                <div class="right-top-bar">
                  <div class="col-md-12">
                    <div class="view-feature">
                      <h3 class="aco_subTitle title text-center pb-1" style="color: blue;">Legality & Responsible Play </h3>
                    </div>
                  </div>
                </div>

                <div class="accordian" id="accordionExample2">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse158" aria-expanded="false" aria-controls="collapse158"> What is a game
                        of skill under Indian laws? </button>
                    </h2>
                    <div id="collapse158" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body">
                        <ul style="list-style-type: disc;">
                          <li>A game of skill is when a player invests his/her time in learning, practising and refining
                            his skill to perform in a particular game. The Supreme Court noted that games of skill would
                            be where.</li>
                          <li>“Success depends principally upon the superior knowledge, training, attention, experience
                            and adroitness of the player. It is also noted by the Supreme Court that a Game of Skill
                            will have a predominance of Skill Factor.</li>
                          <li>The principal legislation governing gambling in India is the Public Gambling Act, 1867
                            (“PGA”). The PGA criminalises the act of ‘gambling’ in a public forum and the keeping of a
                            ‘common gaming house’. The PGA, however, creates an important exception in favour of games
                            of skill, by stating that the provisions of the PGA shall [not] be held to apply to any
                            ‘game of mere skill’ wherever played.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse159" aria-expanded="false" aria-controls="collapse159"> Am I allowed to
                        play if I’m under the age of 18? </button>
                    </h2>
                    <div id="collapse159" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> No, TPL App is strictly for users who are at least 18 years of age.
                        Do you know any TPL App user who is below 18. Report the person from the below link along with a
                        reason why you believe so. </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse160" aria-expanded="false" aria-controls="collapse160"> Can residents
                        of Assam, Andhra Pradesh, Odisha, Telangana, Nagaland or Sikkim join paid contests on TPL App?
                      </button>
                    </h2>
                    <div id="collapse160" class="accordion-collapse collapse " aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample2">
                      <div class="accordion-body"> The laws in Assam, Andhra Pradesh, Odisha, Telangana, Nagaland and
                        Sikkim are unclear on games of skill that may be played for a fee. Hence, residents of these
                        states are not permitted to join any contests on TPL App. </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<p-scrollTop [threshold]="200"></p-scrollTop>